import { render, staticRenderFns } from "./aOrder.vue?vue&type=template&id=bf9af146&scoped=true&"
import script from "./aOrder.vue?vue&type=script&lang=js&"
export * from "./aOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9af146",
  null
  
)

export default component.exports